import { useNavigate } from "react-router";

import { SEOHead } from "@/components/helpers/seo/SEOHead";
import { Box } from "@/components/layout/flexbox";
import { Nav } from "@/components/nav/Nav";
import { Authenticate } from "@/components/pages_logged_in/Authenticate";
import { CoachingDashboard } from "@/components/pieces/coaching/CoachingDashboard";
import { CoachingHeader } from "@/components/pieces/coaching/CoachingHeader";
import { getUser } from "@/components/session/JwtTokenManager";
import {
  LIGHTEST_BACKGROUND,
  SIDE_NAV_WIDTH,
  SITE_NAME,
  STANDARD_APP_MAX_WIDTH,
} from "@/css/constants";

export function CoachingPage() {
  const navigate = useNavigate();
  const user = getUser();

  if (user && !user.name) {
    navigate("/onboard");
    return null;
  }

  return (
    <Authenticate maxWidth="100%" layout="dashboard" showMessageBar={true}>
      <SEOHead
        title={`Coaching Dashboard - ${SITE_NAME}`}
        description="View your upcoming and previous coaching sessions"
        canonicalPath="/dashboard"
      />
      <Nav />
      <Box ml={[0, 0, SIDE_NAV_WIDTH]}>
        <CoachingHeader selectedTab="dashboard" />
        <Box pb={6} bg={LIGHTEST_BACKGROUND}>
          <Box
            className="container"
            maxWidth={STANDARD_APP_MAX_WIDTH}
            m="0 auto"
            px={[3, 24]}
          >
            <Box width={1} mt={4}>
              <CoachingDashboard viewAsCoach={false} />
            </Box>
          </Box>
        </Box>
      </Box>
    </Authenticate>
  );
}
